import {push} from 'connected-react-router';

import {
  SET_ARTICLE,
  CLEAR_ARTICLE,
  SET_LOADING,
  SET_VOTE,
  ArticlesActionTypes,
} from './Types';
import {Article} from '../../Services/ArticleService';
import {ThunkResult} from '../index';

export const setArticle = (article: Article): ArticlesActionTypes => {
  return {
    type: SET_ARTICLE,
    payload: article,
  };
};

export const setLoading = (loading: boolean): ArticlesActionTypes => {
  return {
    type: SET_LOADING,
    payload: loading,
  };
};

export const setArticleCreator = (id: number): ThunkResult<Promise<void>> => {
  return async (dispatch, getState) => {
    const {
      auth: {authorised, articleService},
      router: {
        location: {pathname},
      },
    } = getState();

    if (!authorised) {
      return;
    }

    dispatch(setLoading(true));

    const newPath = `/public/article/${id}`;
    if (newPath !== pathname) {
      dispatch(push(newPath));
    }

    try {
      const res = await articleService.byId(id);
      if (res.parsedBody !== undefined) {
        dispatch(setArticle(res.parsedBody));
      }
    } catch (e) {
      console.log(e);
    }

    dispatch(setLoading(false));
  };
};

export const clearArticle = (): ArticlesActionTypes => {
  return {
    type: CLEAR_ARTICLE,
  };
};

export const setVote = (id: number, vote?: boolean) => {
  return {
    type: SET_VOTE,
    payload: {
      id,
      vote,
    },
  };
};

export const getVoteCreator = (id: number): ThunkResult<Promise<void>> => {
  return async (dispatch, getState) => {
    const {
      auth: { authorised, articleService },
      articles: { votes },
    } = getState();

    if (!authorised) {
      return;
    }

    if (votes[id] !== undefined) {
      return;
    }

    try {
      const vote = await articleService.getVote(id);
      dispatch(setVote(id, vote.parsedBody));
    } catch {
      dispatch(setVote(id));
    }
  };
};

